import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import EImage from '../views/EImage.vue'
import EPdf from '../views/EPdf.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { title: '建安汇水印助手' }
  },
  {
    path: '/EImage',
    name: 'EImage',
    component: EImage,
    meta: { title: '建安汇图片助手' }
  },
  {
    path: '/EPdf',
    name: 'EPdf',
    component: EPdf,
    meta: { title: '建安汇PDF助手' }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

export default router
